module.exports = __webpack_public_path__ + "images/10bd594225bc54973dbeb06c9596d4034fac2bac5320d30c1ab655b85a012e5b.svg";